<div id="datePicker">
  <label for="startDate">Start Date: &nbsp;</label>
  <p-datepicker id="startDate" [(ngModel)]="startDate" [showIcon]="true" (ngModelChange)="onDateChange()"></p-datepicker>

  <span style="margin-left: 15px;">
    @if (timerPaused) {
      <i class="fa fa-play"  (click)="startTimer()"></i>
    }
    @if (!timerPaused) {
      <i class="fa fa-pause" (click)="pauseTimer()"></i>
    }
    {{timeLeft | time}} until refresh
  </span>

  <span style="float: right;">
    <p-button type="button" label="Notify All Customers" severity="secondary" class="" (click)="showDialog(bucketListDayList)" [disabled]="!canDrag"></p-button>
  </span>
</div>

@if (displayScheduleDialog) {
  <p-dialog header="Schedule" [(visible)]="displayScheduleDialog" [modal]="true"
    [resizable]="false" [baseZIndex]="10000" appendTo="body">
    <div class="form-group">
      {{message}}
    </div>
    <div class="form-group" style="margin-top: 5px">
      <p-button type="button" type="submit" (click)="scheduleDays()" label="Yes"></p-button>&nbsp;
      <p-button type="button" (click)="displayScheduleDialog=false" label="No" severity="info"></p-button>
    </div>
  </p-dialog>
}

@if (displayErrorScheduleDialog) {
  <p-dialog header="Schedule" [(visible)]="displayErrorScheduleDialog" [modal]="true"
    [resizable]="false" [baseZIndex]="10000" appendTo="body">
    <form [formGroup]="commentForm">
      <div class="form-group">
        {{message}}
        <textarea pInputTextarea formControlName="errorComment" class="form-control" [required]="true"
        style="width: 100%;" autoResize="autoResize"></textarea>
      </div>
      <div class="form-group" style="margin-top: 5px">
        <p-button type="button" type="submit" [disabled]="commentForm.invalid" (click)="scheduleDays()"
        label="Yes"></p-button>&nbsp;
        <p-button type="button" (click)="displayErrorScheduleDialog=false" label="No"
        severity="info"></p-button>
      </div>
    </form>
  </p-dialog>
}

<p-dialog header="Confirmation" [(visible)]="displayConfirmationDialog" [modal]="true"
  [resizable]="false" [baseZIndex]="10000" appendTo="body">
  <div>
    {{confirmMessage}}
  </div>
  <div class="footer">
    <p-button type="button" (click)="displayConfirmationDialog=false" label="Ok"
    severity="info"></p-button>
  </div>
</p-dialog>

<div id="fiveDayCalendar" class="p-grid" style="z-index: 900000; height: 91%;">
  <p-card id="dayOne" class="p-col" cdkDropList  [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[0].bucketList"
    [cdkDropListConnectedTo]="['dayTwo', 'dayThree', 'dayFour', 'dayFive', 'daySix', 'daySeven']"
    (cdkDropListDropped)="drop($event)">
    <p-header class="date-header">
      @if (canDrag) {
        <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar" [(ngModel)]="rescheduleDate" [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[0])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[0].day | date: 'EEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
        (click)="addNewCrew(bucketListDayList[0])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
      (click)="showDialog([bucketListDayList[0]])"></p-button>
    </p-header>
    @if (indexHasUnavailableEquipmentOrEmployees(0)) {
      <app-unavailable-equipment-and-employees
        [bigEquipment]="unavailableEquipment[0]"
        [bigEmployees]="unavailableEmployees[0]"
        [type]="isWellness ? 'wellness' : 'work'">
      </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[0].bucketList; track item) {
      <div
        cdkDrag
        [cdkDragDisabled]="disableDrag(item)">
        <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
          (needsValidated)="validateDay(bucketListDayList[0].day)" (dragStartEvent)="woDragStart($event, item.id)"
          (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
          (taskDragEndEvent)="taskDraggedEnded()"
          [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
      </div>
    }
  </p-card>
  <p-card id="dayTwo" class="p-col" cdkDropList  [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[1].bucketList"
    [cdkDropListConnectedTo]="['dayOne', 'dayThree', 'dayFour', 'dayFive', 'daySix', 'daySeven']"
    (cdkDropListDropped)="drop($event)">
    <p-header>
      @if (canDrag) {
        <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar" [(ngModel)]="rescheduleDate" [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[1])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[1].day | date: 'EEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
        (click)="addNewCrew(bucketListDayList[1])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
      (click)="showDialog([bucketListDayList[1]])"></p-button>
    </p-header>
    @if (indexHasUnavailableEquipmentOrEmployees(1)) {
      <app-unavailable-equipment-and-employees
        [bigEquipment]="unavailableEquipment[1]"
        [bigEmployees]="unavailableEmployees[1]"
        [type]="isWellness ? 'wellness' : 'work'">
      </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[1].bucketList; track item) {
      <div cdkDrag
        [cdkDragDisabled]="disableDrag(item)">
        <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
          (needsValidated)="validateDay(bucketListDayList[1].day)" (dragStartEvent)="woDragStart($event, item.id)"
          (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
          (taskDragEndEvent)="taskDraggedEnded()"
          [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
      </div>
    }
  </p-card>
  <p-card id="dayThree" class="p-col" cdkDropList  [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[2].bucketList"
    [cdkDropListConnectedTo]="['dayOne', 'dayTwo', 'dayFour', 'dayFive', 'daySix', 'daySeven']"
    (cdkDropListDropped)="drop($event)">
    <p-header>
      @if (canDrag) {
        <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar" [(ngModel)]="rescheduleDate" [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[2])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[2].day | date: 'EEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
        (click)="addNewCrew(bucketListDayList[2])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
      (click)="showDialog([bucketListDayList[2]])"></p-button>
    </p-header>
    @if (indexHasUnavailableEquipmentOrEmployees(2)) {
      <app-unavailable-equipment-and-employees
        [bigEquipment]="unavailableEquipment[2]"
        [bigEmployees]="unavailableEmployees[2]"
        [type]="isWellness ? 'wellness' : 'work'">
      </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[2].bucketList; track item) {
      <div cdkDrag
        [cdkDragDisabled]="disableDrag(item)">
        <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
          (needsValidated)="validateDay(bucketListDayList[2].day)" (dragStartEvent)="woDragStart($event, item.id)"
          (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
          (taskDragEndEvent)="taskDraggedEnded()"
          [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
      </div>
    }
  </p-card>
  <p-card id="dayFour" class="p-col" cdkDropList  [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[3].bucketList"
    [cdkDropListConnectedTo]="['dayOne', 'dayTwo', 'dayThree', 'dayFive', 'daySix', 'daySeven']"
    (cdkDropListDropped)="drop($event)">
    <p-header>
      @if (canDrag) {
        <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar" [(ngModel)]="rescheduleDate" [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[3])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[3].day | date: 'EEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
        (click)="addNewCrew(bucketListDayList[3])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
      (click)="showDialog([bucketListDayList[3]])"></p-button>
    </p-header>
    @if (indexHasUnavailableEquipmentOrEmployees(3)) {
      <app-unavailable-equipment-and-employees
        [bigEquipment]="unavailableEquipment[3]"
        [bigEmployees]="unavailableEmployees[3]"
        [type]="isWellness ? 'wellness' : 'work'">
      </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[3].bucketList; track item) {
      <div cdkDrag
        [cdkDragDisabled]="disableDrag(item)">
        <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
          (needsValidated)="validateDay(bucketListDayList[3].day)" (dragStartEvent)="woDragStart($event, item.id)"
          (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
          (taskDragEndEvent)="taskDraggedEnded()"
          [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
      </div>
    }
  </p-card>
  <p-card id="dayFive" class="p-col" cdkDropList  [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[4].bucketList"
    [cdkDropListConnectedTo]="['dayOne', 'dayTwo', 'dayThree', 'dayFour', 'daySix', 'daySeven']"
    (cdkDropListDropped)="drop($event)">
    <p-header>
      @if (canDrag) {
        <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar" [(ngModel)]="rescheduleDate" [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[4])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[4].day | date: 'EEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
        (click)="addNewCrew(bucketListDayList[4])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
      (click)="showDialog([bucketListDayList[4]])"></p-button>
    </p-header>
    @if (indexHasUnavailableEquipmentOrEmployees(4)) {
      <app-unavailable-equipment-and-employees
        [bigEquipment]="unavailableEquipment[4]"
        [bigEmployees]="unavailableEmployees[4]"
        [type]="isWellness ? 'wellness' : 'work'">
      </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[4].bucketList; track item) {
      <div cdkDrag
        [cdkDragDisabled]="disableDrag(item)">
        <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
          (needsValidated)="validateDay(bucketListDayList[4].day)" (dragStartEvent)="woDragStart($event, item.id)"
          (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
          (taskDragEndEvent)="taskDraggedEnded()"
          [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
      </div>
    }
  </p-card>
  <p-card id="daySix" class="p-col" cdkDropList  [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[5].bucketList"
    [cdkDropListConnectedTo]="['dayOne', 'dayTwo', 'dayThree', 'dayFour', 'dayFive', 'daySeven']"
    (cdkDropListDropped)="drop($event)">
    <p-header>
      @if (canDrag) {
        <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar" [(ngModel)]="rescheduleDate" [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[5])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[5].day | date: 'EEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
        (click)="addNewCrew(bucketListDayList[5])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
      (click)="showDialog([bucketListDayList[5]])"></p-button>
    </p-header>
    @if (indexHasUnavailableEquipmentOrEmployees(5)) {
      <app-unavailable-equipment-and-employees
        [bigEquipment]="unavailableEquipment[5]"
        [bigEmployees]="unavailableEmployees[5]"
        [type]="isWellness ? 'wellness' : 'work'">
      </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[5].bucketList; track item) {
      <div cdkDrag
        [cdkDragDisabled]="disableDrag(item)">
        <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
          (needsValidated)="validateDay(bucketListDayList[5].day)" (dragStartEvent)="woDragStart($event, item.id)"
          (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
          (taskDragEndEvent)="taskDraggedEnded()"
          [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
      </div>
    }
  </p-card>
  <p-card id="daySeven" class="p-col" cdkDropList  [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[6].bucketList"
    [cdkDropListConnectedTo]="['dayOne', 'dayTwo', 'dayThree', 'dayFour', 'dayFive', 'daySix']"
    (cdkDropListDropped)="drop($event)">
    <p-header>
      @if (canDrag) {
        <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar special" [(ngModel)]="rescheduleDate" [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[6])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[6].day | date: 'EEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
        (click)="addNewCrew(bucketListDayList[6])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
      (click)="showDialog([bucketListDayList[6]])"></p-button>
    </p-header>
    @if (indexHasUnavailableEquipmentOrEmployees(6)) {
      <app-unavailable-equipment-and-employees
        [bigEquipment]="unavailableEquipment[6]"
        [bigEmployees]="unavailableEmployees[6]"
        [type]="isWellness ? 'wellness' : 'work'">
      </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[6].bucketList; track item) {
      <div cdkDrag
        [cdkDragDisabled]="disableDrag(item)">
        <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
          (needsValidated)="validateDay(bucketListDayList[6].day)" (dragStartEvent)="woDragStart($event, item.id)"
          (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
          (taskDragEndEvent)="taskDraggedEnded()"
          [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
      </div>
    }
  </p-card>
</div>
